define('modules/form_editor/models/custom_month',['require','exports','module','./dropdown','./custom_month_item'],function(require, exports, module){
  "use strict";
  var DropDown = require("./dropdown"),
      CustomMonthItem = require("./custom_month_item");

  var MONTHS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

  module.exports = DropDown.extend({
    name: "custom:month",
    initialize: function(attrs,options){
      module.exports.__super__.initialize.call(this,attrs,options);
      if (this.items.length === 1){
        //first use of this model, no items yet
        this.items.first().set("translationKey", "formEditor.selectMonth");
        MONTHS.forEach(function(text){
          this.addItem({
            valid: true,
            translationKey: "formEditor.months." + text
          });
        }.bind(this));
      }
      else {
        //we already had saved month items
        var tKey = this.items.first().get("translationKey");
        //backwards compatibility, change saved translation key
        if(tKey === "formEditor.default"){
          this.items.first().set("translationKey", "formEditor.selectMonth");
        }
      }
    },
  });

});

